import React, {useRef, useState} from "react";
import {Box, Text} from "grommet";
import {useRouter} from "next/router";
import OAuthManager from "./OAuthManager";
import {handleErrors} from "../utils/errors";
import StatusMessage from "./StatusMessage";
import Button from "./Button";

const LinkHubSpot = ({ userId, onLinked, ctaColor, buttonWrapperProps, refreshPage = false }) => {
    const [isOauthWindowOpen, setIsOauthWindowOpen] = useState(false);
    const [oauthError, setOauthError] = useState();
    const oAuthManagerRef = useRef();
    const router = useRouter();

    const onSubmit = () => {
        fetch('/api/signup/hubspot', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: userId }),
        })
            .then(handleErrors)
            .catch(setOauthError)
            .then((data) => {
                if (data?.auth_url) {
                    oAuthManagerRef.current.showAuthDialog(data.auth_url);
                }
            });
    };

    const onComplete = () => {
        setIsOauthWindowOpen(false);
        onLinked?.();
        if (refreshPage) {
            router.reload();
        }
    };

    const onError = (err) => {
        setIsOauthWindowOpen(false);
        setOauthError(err);
    };

    const onDismiss = () => {
        setIsOauthWindowOpen(false);
        setOauthError(undefined);
    };

    const onOpen = () => {
        setOauthError(undefined);
        setIsOauthWindowOpen(true);
    };

    return (
        <Box>
            <OAuthManager
                ref={oAuthManagerRef}
                onComplete={onComplete}
                onError={onError}
                onDismiss={onDismiss}
                onOpen={onOpen}
            />
            {oauthError && <StatusMessage apiError={oauthError} condensed fontSize="xsmall" />}

            <Box pad={{ vertical: 'medium', horizontal: 'none' }} {...buttonWrapperProps}>
                <Button
                    event={{ section: 'link_hubspot', element: 'submit' }}
                    onClick={onSubmit}
                    primary
                    label={<Text color="text">Connect HubSpot</Text>}
                    disabled={isOauthWindowOpen}
                    data-testid="hubspot-connect-submit"
                    {...(ctaColor ? { color: ctaColor } : {})}
                />
            </Box>
        </Box>
    );
};

export default LinkHubSpot;
